import PropTypes from "prop-types";
import React from "react";
import { Checkboxes } from "cxa-form-field";
import { FormattedMessage } from "react-intl";
const CheckboxType = ({ question }) =>
  <div>
    <p>
      <FormattedMessage
        id={question.questionText}
        defaultMessage={question.questionText}
      />
    </p>
    <Checkboxes
      items={question.questionOptions}
      valueKey="questionOptionId"
      labelKey="options"
      name={`question_${question.tag}`}
    />
  </div>;

CheckboxType.propTypes = { question: PropTypes.object };

export default CheckboxType;



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/questionnaire/display-types/checkbox.jsx